import dayjs from 'dayjs'

export const timeDurationMap = (_: unknown, index: number) => {
  const isOdd = (index + 1) % 2 === 1
  const hourAmount = Math.floor((index + 1) / 2)

  const label = `${index !== 0 ? `${hourAmount} ${hourAmount === 1 ? 'hour' : 'hours'}` : '30 minutes'}${
    isOdd && index !== 0 ? ' and 30 minutes' : ''
  }`
  const value = `${hourAmount}${isOdd ? '.5' : ''}`
  return { label, value }
}

export const timeslotsMap = (startHour: string, endHour: string) => {
  const baseDate = new Date().toISOString().split('T')[0]
  let startDate = dayjs(new Date(`${baseDate}T${startHour}`))

  const endDate = dayjs(new Date(`${baseDate}T${endHour}`))
  let label
  const timeslots = []
  while (startDate < endDate) {
    const hour = startDate.hour()
    const minute = startDate.format('mm')
    const isPM = hour >= 12
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12
    label = `${formattedHour}:${minute} ${isPM ? 'p.m.' : 'a.m.'}`
    timeslots.push({
      label,
      value: startDate.format('HH:mm'),
    })
    startDate = startDate.add(30, 'minute')
  }
  return timeslots
}

export const capacityMap = (_: unknown, i: number) => ({
  label: i === 10 ? '11 or more' : `${i + 1}`,
  value: `${i + 1}`,
})
